/**
 * Pre-compiled fr-FR messages for SplitButton
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { noActionsAvailable: `Aucune action disponible` };
